export default {
    "Enabled": "Activé",
    "Disabled": "Désactivé",
    "Display alerts when detecting quality issue ; Automatically enabled when source goes up":
        "Afficher les alertes lors de la détection d'un problème de qualité ; Activé automatiquement lorsque la source est active",

    // Common dialog buttons
    "Close": "Fermer",
    "Cancel": "Annuler",
    "Confirm": "Confirmer",
    "Save": "Enregistrer",

    // FMultiUpload
    "files uploaded": "fichiers téléchargés",
    "Remove all": "Tout supprimer",
    "No file uploaded": "Aucun fichier téléchargé",
    "Play your video file in loop": "Lire votre fichier vidéo en boucle",
    "Upload": "Téléverser",

    // FPassword
    "SHOW": "AFFICHER",
    "HIDE": "MASQUER",

    // FField
    "Optional": "Facultatif",

    // FProjectTabs
    "Add tab": "Ajouter un onglet",
    "no tab selected": "aucun onglet sélectionné",

    // VFigmaPage section titles
    "Buttons": "Boutons",
    "Buttons Overlay": "Boutons en Superposition",
    "Links": "Liens",
    "Links Overlay": "Liens en Superposition",
    "Buttons Specials": "Boutons Spéciaux",
    "Input": "Entrée",
    "Value": "Valeur",
    "Toggle": "Interrupteur",
    "Dialogs": "Dialogues",
    "Select": "Sélection",
    "Upload": "Téléversement",
    "FLoaderCircular": "Chargement Circulaire",

    // FSelect
    "Empty": "Vide",
    "No value": "Aucune valeur",
}
